//
//
//
//
//
//
//
//
//
//

// @ts-nocheck
export default {
    props: {
        sitekey: {
            type: String,
            default: '',
        },
        sitekeyV3: {
            type: String,
            default: '',
        },
        theme: {
            type: String,
            default: 'dark',
        },
        badge: {
            type: String,
            default: 'inline',
        },
        type: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'invisible',
        },
        tabindex: {
            type: String,
            default: '',
        },
        tcCopy: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            widgetId: 'recap',
        };
    },
    methods: {
        renderRecap() {
            if (!window.grecaptcha) {
                return;
            }

            window.grecaptcha.ready(() => {
                window.grecaptcha.render(this.widgetId, {
                    sitekey: this.sitekey,
                    theme: this.theme,
                    size: this.size,
                    badge: 'inline',
                    callback: this.emitVerify,
                    'callback-expired': this.emitExpired,
                });
            });
        },
        reset() {
            try {
                window.grecaptcha.reset();
            } catch (error) {
                console.error(error);
                this.renderRecap();
            }
        },
        execute() {
            if (!window.grecaptcha) {
                return;
            }

            window.grecaptcha.ready(() => {
                // excecute recaptcha v3 first and if the threshold is low trigger recaptcha v2
                window.grecaptcha.execute(this.sitekeyV3, { action: 'login' }).then(token => {
                    this.$axios.post('/api/recaptcha/verify/v3', {
                        token,
                    }).then(response => {
                        if (response.data.skipRecaptchaV2) {
                            this.emitVerify();
                        } else {
                            window.grecaptcha.execute();
                        }
                    }).catch(() => {
                        window.grecaptcha.execute();
                    });
                });
            });
        },
        emitVerify(response) {
            this.$emit('verify', response);
        },
        emitExpired() {
            this.$emit('expired');
        },
    },
};
